// The supplied mark is monochrome black, which disappears against the hybrid
// basemap. Every shape takes `currentColor` so the colour lives in CSS, where
// the drop shadow that separates it from the imagery is also defined. Only one
// variant is needed: the basemap is visually uniform across the ASF area.
//
// Hand-converted from the source at ./natlink-logo.svg (the source of truth
// for future edits): fill="black" -> fill="currentColor", fill-rule/clip-rule
// -> fillRule/clipRule, and the XML prolog/DOCTYPE plus the xml:space,
// shape-rendering, text-rendering and image-rendering attributes dropped —
// none of them affect a React-rendered inline SVG.
export function NatlinkLogo() {
  return (
    <svg
      className="asf-logo"
      viewBox="0 0 17589.8 3899.9"
      role="img"
      aria-label="Natlink"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M4818 3004.1c-126,140.8 -287.6,209.3 -494,209.3 -191.4,0 -345.6,-70.8 -471.3,-216.1 -123.4,-144.8 -186.1,-337.1 -186.1,-571.3 0,-220.8 62.5,-400.5 190.6,-548.6 127.9,-144.2 282.3,-214.4 472.2,-214.4 202.6,0 362.3,69.3 487.8,211 126.9,146.7 191.2,337 191.2,565.6 0,228.5 -64.3,418.8 -190.4,564.5zm152.5 -1746.6c-226.6,-190.2 -479.9,-286.4 -754.9,-286.4 -375,0 -691.7,141 -941.1,419 -247.5,275.8 -373,624.4 -373,1035.9 0,418.5 125.3,773.3 373.2,1055.1 251.2,277.9 573.3,418.8 957.2,418.8 260.4,0 508.3,-90.4 738.6,-269l0 193.2 754.2 0 0 -2779.9 -754.2 0 0 213.3z"
      />
      <polygon
        fill="currentColor"
        fillRule="nonzero"
        points="7464.8,77.4 6713.3,77.4 6713.3,1044.2 6271.8,1044.2 6271.8,1755.1 6713.3,1755.1 6713.3,3824.1 7464.8,3824.1 7464.8,1755.1 7938.7,1755.1 7938.7,1044.2 7464.8,1044.2"
      />
      <polygon
        fill="currentColor"
        fillRule="nonzero"
        points="8412.4,3824.1 9163.9,3824.1 9163.9,77.5 8412.4,77.5"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M10248.7 0c-114.6,0 -214.3,41.6 -296.3,123.5 -82,82 -123.6,180.9 -123.6,293.9 0,117.9 41.6,219.2 123.6,301.2 82,81.9 182.5,123.5 298.7,123.5 116.5,0 216.4,-41.8 296.3,-123.5 82,-82 123.5,-182.5 123.5,-298.8 0,-116.5 -41.7,-216.4 -123.5,-296.3 -82.1,-81.9 -182.5,-123.5 -298.7,-123.5z"
      />
      <polygon
        fill="currentColor"
        fillRule="nonzero"
        points="9874.1,3824.1 10625.6,3824.1 10625.6,1064.4 9874.1,1064.4"
      />
      <polygon
        fill="currentColor"
        fillRule="nonzero"
        points="16909.5,1044.2 15886.5,1044.2 15128.5,1797.5 15128.5,77.4 14377,77.4 14377,3824.1 15128.5,3824.1 15128.5,2766.9 15148.4,2747 15992.3,3824.1 16966,3824.1 15684.3,2229"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M2051.7 1238.4c-220.7,-191.7 -503.2,-288.9 -839.4,-288.9 -338.1,0 -621.4,97.2 -842.7,289.3 -134.4,118.9 -230.5,255 -286.2,406.2 -55.4,162.3 -83.4,356.4 -83.4,577.1l0 1618.3 759.5 0 0 -1604.6c0,-531.3 258.4,-592.7 452.8,-592.7 194.4,0 452.9,61.4 452.9,592.7l0 1604.6 759.4 0 0 -1618.3c0,-256.9 -26.9,-447 -81.5,-579.5 -57,-149.3 -155,-285.3 -291.4,-404.2z"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M13384.2 1238.4c-220.8,-191.7 -503.2,-288.9 -839.5,-288.9 -338,0 -621.3,97.2 -842.6,289.3 -134.4,118.9 -230.5,255 -286.3,406.2 -55.3,162.3 -83.4,356.4 -83.4,577.1l0 1618.3 759.5 0 0 -1604.6c0,-531.3 258.4,-592.7 452.8,-592.7 194.5,0 452.9,61.4 452.9,592.7l0 1604.6 759.4 0 0 -1618.3c0,-257 -26.9,-447.1 -81.4,-579.5 -57,-149.3 -155,-285.3 -291.4,-404.2z"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M17297.2 1351.9l-46.3 0 0 -70.8 48.9 0c17.5,0 28.8,20.1 28.8,34.1 0,17.5 -11.3,36.7 -31.4,36.7zm106.6 -36.7c0,-49.8 -32.4,-99.6 -102.3,-99.6l-124 0 0 296.2 73.4 0 0 -95.3 6.1 0 63.8 95.3 88.2 0 -73.4 -98.7c44.6,-14.9 68.2,-54.2 68.2,-97.9z"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M17284.1 1603.5c-131.9,0 -236.8,-107.5 -236.8,-239.4 0,-131.9 104.9,-240.2 236.8,-240.2 131.9,0 236.7,108.3 236.7,240.2 0,131.9 -104.8,239.4 -236.7,239.4zm0 -548.7c-170.4,0 -304.9,139 -304.9,309.3 0,170.4 134.5,308.4 304.9,308.4 170.4,0 305.7,-138 305.7,-308.4 0,-170.3 -135.3,-309.3 -305.7,-309.3z"
      />
    </svg>
  )
}
